import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  CloseAccountCardContentRouteProps,
  closeAccountContentRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import { selectCreditCardListModelsFromState } from 'src/redux/selectors/data/creditCards.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'

export const selectCreditCardIdFromRoute = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<CloseAccountCardContentRouteProps>(
      location.pathname,
      closeAccountContentRouteProps,
    ) as match<CloseAccountCardContentRouteProps>
    return mtch.params.id
  },
)

export const selectCreditCard = createSelector(
  [selectCreditCardListModelsFromState, selectCreditCardIdFromRoute],
  (creditCards, creditCardId) => {
    return creditCards[creditCardId] !== undefined
      ? creditCards[creditCardId]
      : undefined
  },
)

export const selectPuttingCloseAccountFromState = (state: RootState): boolean =>
  state.app.closeAccountContent.puttingCloseAccount

export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.closeAccountContent.topLevelError
